module.exports = __webpack_public_path__ + "static/media/ic-badge.inscrito.5738789f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Icons Network/ic-badge.inscrito.svg
// module id = 247
// module chunks = 0